import { Modal } from "bootstrap"
import React, { createRef, useEffect, useState } from "react"
import { disablePartner, updatePartnerType } from "../services/firebase/firebase";

export const EditPartner = React.forwardRef((props, ref) => {

    const [loading, setLoading] = useState(false)
    const [type, setType] = useState('Socio de Transito')

    const { data, hideModal } = props

    const doDisable = (e) => {
        e.preventDefault()
        setLoading(true)
        let state = 'disabled'
        if (data.status === 'disabled') state = 'active'
        disablePartner(data.email, state)
            .then(response => {
                alert(response)
                hideModal(ref.current)
            })
            .catch(error => {
                alert(error.code)
                hideModal(ref.current)
            })
    }

    const doUpdate = (e) => {
        e.preventDefault()
        setLoading(true)
        updatePartnerType(data.email, type)
            .then(response => {
                setLoading(false)
                alert(response)
                hideModal(ref.current)
            })
            .catch(error => {
                setLoading(false)
                alert(error.code)
                hideModal(ref.current)
            })
    }

    useEffect(() => {
        setType(data.type)
    }, [])

    return (
        <div className="modal fade" ref={ref} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered" style={{ minWidth: '900px' }}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Información de Socio</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body text-start">
                        <div className='container row'>
                            <div className="col-6">
                                <div className="row align-items-center justify-content-between my-3">
                                    <div className="col-sm-12 mb-sm-2 col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="firstname"
                                            value={data?.firstname}
                                            placeholder="Nombre *"
                                            disabled
                                        />
                                    </div>
                                    <div className="col-sm-12 mb-sm-2 col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="lastname"
                                            value={data?.lastname}
                                            placeholder="Apellidos"
                                            disabled
                                        />
                                    </div>
                                    <div className="col-sm-12 mb-sm-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="email"
                                            value={data?.email}
                                            placeholder="Email"
                                            disabled
                                        />
                                    </div>
                                    <div className="col-sm-12  mb-sm-2 col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="tlf"
                                            value={data?.tlf}
                                            placeholder="Teléfono"
                                            disabled
                                        />
                                    </div>
                                    <div className="col-sm-12  mb-sm-2 col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="dni"
                                            value={data?.dni}
                                            placeholder="DNI/NIE/Pasaporte"
                                            disabled
                                        />
                                    </div>
                                    <div className="col-sm-12 mb-sm-2 col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="company"
                                            value={data?.company}
                                            placeholder="Empresa"
                                            disabled
                                        />
                                    </div>
                                    <div className="col-sm-12 mb-sm-2 col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="role"
                                            value={data?.role}
                                            placeholder="Profesión"
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="row justify-content-start align-items-center my-3">
                                    <div className="col-sm-12 mb-sm-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="dir"
                                            value={data?.dir}
                                            placeholder="Dirección"
                                            disabled
                                        />
                                    </div>
                                    <div className="col-sm-12 mb-sm-2 col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="cp"
                                            value={data?.cp}
                                            placeholder="CP"
                                            disabled
                                        />
                                    </div>
                                    <div className="col-sm-12 mb-sm-2 col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="city"
                                            value={data?.city}
                                            placeholder="Ciudad"
                                            disabled
                                        />
                                    </div>
                                    <div className="col-sm-12 mb-sm-2 col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="state"
                                            value={data?.state}
                                            placeholder="Provincia"
                                            disabled
                                        />
                                    </div>
                                    <div className="col-sm-12 mb-sm-2 col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="country"
                                            value={data?.country}
                                            placeholder="País"
                                            disabled
                                        />
                                    </div>
                                    <div className="col-sm-12 mb-sm-2 ">
                                        <select className="form-select" name="type" value={type} onChange={e => setType(e.target.value)}>
                                            <option value="Socio de Transito">Socio de Tránsito</option>
                                            <option value="Socio Permanente">Socio Permanente</option>
                                            <option value='Socio de Honor'>Socio de Honor</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='modal-footer justify-content-between'>
                        <button type="button" className="btn btn-danger" onClick={doDisable}>
                            {data.status === 'disabled' ? 'Activar Socio' : 'Desactivar Socio'}
                        </button>
                        <button type="button" className="btn btn-dark" onClick={doUpdate}>
                            {loading ?
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                : 'Actualizar'
                            }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
});

const Partner = ({ data: partner }) => {
    const modalRef = createRef()

    const showModal = () => {
        const modalEle = modalRef.current
        const bsModal = new Modal(modalEle, {
            backdrop: 'static',
            keyboard: false
        })
        bsModal.show()
    }

    const hideModal = () => {
        const modalEle = modalRef.current
        const bsModal = Modal.getInstance(modalEle)
        bsModal.hide()
        // refresh()
    }

    const getPartnerColor = () => {
        if (partner.type === 'Socio Fundador') return '#c8e5eb'
        if (partner.type === 'Socio de Honor') return '#F0E68C'
        if (partner.type === 'Socio Permanente') return '#BEBEBE'
        return ''
    }

    const doDisable = (e) => {
        e.preventDefault()
        let state = 'disabled'
        if (partner.status === 'disabled') state = 'active'
        disablePartner(partner.email, state)
            .then(response => {
                alert(response)
                // refresh()
            })
            .catch(error => {
                alert(error.code)
                // refresh()
            })
    }

    return (
        <tr>
            <td valign="middle">{partner?.firstname}</td>
            <td valign="middle">{partner?.lastname}</td>
            <td valign="middle">{partner?.email}</td>
            <td valign="middle">{partner?.tlf}</td>
            <td valign="middle">{partner?.dni}</td>
            <td valign="middle" style={{ color: partner?.status === 'disabled' ? 'red' : partner?.status === 'active' ? 'green' : 'black' }}>{partner?.status?.toUpperCase()}</td>
            <td valign="middle">
                <div className="card" style={{ backgroundColor: getPartnerColor() }}>
                    {partner.type}
                </div>
            </td>
            <td valign="middle">
                {partner?.status !== 'admin' &&
                    <div>
                        <button className="btn btn-sm btn-outline-success me-1"
                            onClick={showModal}>
                            <i className="fa fa-pencil" style={{ fontSize: '18px' }} />
                        </button>
                        <button className="btn btn-sm btn-outline-danger" onClick={doDisable}>
                            <i className={`fa fa-${partner?.status === 'disabled' ? 'sign-in' : 'trash'}`} style={{ fontSize: '18px' }} />
                        </button>
                        <EditPartner data={partner} hideModal={hideModal} ref={modalRef} />
                    </div>
                }
            </td>
        </tr>
    )
}

export default Partner;